// page init
jQuery(function () {
  initTabs();
  initOpenClose();
  initSlickSlider();
});

// content tabs init
function initTabs() {
  jQuery(".tabset").tabset({
    tabLinks: "a",
    defaultTab: true,
  });

  jQuery(".color-tabset").tabset({
    tabLinks: "[data-href]",
    defaultTab: true,
    attrib: "data-href",
    event: "click",
  });
}

// open-close init
function initOpenClose() {
  jQuery(".open-close").openClose({
    activeClass: "active",
    opener: ".opener, .opener-wrap",
    slider: ".slide",
    animSpeed: 400,
    effect: "slide",
  });

  jQuery(".default-open-close").openClose({
    activeClass: "default-active",
    opener: ".default-opener",
    slider: ".default-slide",
    animSpeed: 400,
    hideOnClickOutside: true,
    effect: "none",
    onInit: function () {
      var self = this;

      this.holder.on(
        "click",
        'a[href^="#"]:not([href="#"]), .fake-radio',
        function (e) {
          console.log(e.currentTarget);
          if (self.holder.hasClass(self.options.activeClass)) {
            self.hideSlide();
            self.opener
              .find(".text-active")
              .html(jQuery(e.currentTarget).text());
          }
        }
      );
    },
  });

  jQuery(".controls-mod").openClose({
    activeClass: "active",
    opener: ".opener",
    slider: ".slide",
    animSpeed: 400,
    hideOnClickOutside: false,
    effect: "slide",
    onInit: function () {
      var self = this;
      var $selectedItem = self.holder.find(".selected-item");

      this.holder.on("change", function (e) {
        if (self.holder.hasClass(self.options.activeClass)) {
          var $target = jQuery(e.target);

          self.hideSlide();

          if ($target.is(":radio")) {
            $selectedItem.html(
              $target.closest(".color-radio").find("figure").html() ||
                $target.closest("label").text()
            );
          } else if ($target.is("select")) {
            $selectedItem.html($target.val());
          }
        }
      });
    },
  });
}

// slick slider init
function initSlickSlider() {
  jQuery(".default-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: true,
    dots: false,
    arrows: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    prevArrow: '<span class="slick-prev"><span>&and;</span></span>',
    nextArrow: '<span class="slick-next"><span>&and;</span></span>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          prevArrow: '<span class="slick-prev"><span>more</span></span>',
          nextArrow: '<span class="slick-next"><span>more</span></span>',
        },
      },
    ],
  });

  jQuery(".collections-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
        },
      },
    ],
  });

  jQuery(".service-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
        },
      },
    ],
  });

  jQuery(".responsive-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
        },
      },
    ],
  });

  $(".product-slider").on("init", function (event, slick) {
    jQuery(".zoomContainer").remove();
    jQuery(this).find(".slick-slide.slick-current .zoomImage").elevateZoom({
      zoomType: "inner",
      cursor: "pointer",
    });

    if (jQuery(window).width() < 768) {
      jQuery(".zoomContainer").hide();
    }
  });
  jQuery(".product-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: false,
    dots: true,
    arrows: false,
  });

  jQuery(".product-slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      jQuery(".zoomContainer").remove();
      jQuery(this).find(".slick-slide.slick-current .zoomImage").elevateZoom({
        zoomType: "inner",
        cursor: "pointer",
      });
      if (jQuery(window).width() < 768) {
        jQuery(".zoomContainer").hide();
      }
    }
  );

  jQuery(".rotate-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: true,
    dots: false,
    arrows: false,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $(".rotate-sliders-first").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: true,
    dots: false,
    arrows: false,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: ".rotate-sliders-second",
  });

  $(".rotate-sliders-second").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: true,
    dots: false,
    arrows: false,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: ".rotate-sliders-first",
  });

  jQuery(".hero-slider").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    infinite: true,
    dots: true,
    arrows: false,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
  });
}

/*!
 * SmoothScroll module
 */
(function ($, exports) {
  // private variables
  var page,
    win = $(window),
    activeBlock,
    activeWheelHandler,
    wheelEvents =
      "onwheel" in document || document.documentMode >= 9
        ? "wheel"
        : "mousewheel DOMMouseScroll";

  // animation handlers
  function scrollTo(offset, options, callback) {
    // initialize variables
    var scrollBlock;
    if (document.body) {
      if (typeof options === "number") {
        options = {
          duration: options,
        };
      } else {
        options = options || {};
      }
      page = page || $("html, body");
      scrollBlock = options.container || page;
    } else {
      return;
    }

    // treat single number as scrollTop
    if (typeof offset === "number") {
      offset = {
        top: offset,
      };
    }

    // handle mousewheel/trackpad while animation is active
    if (activeBlock && activeWheelHandler) {
      activeBlock.off(wheelEvents, activeWheelHandler);
    }
    if (options.wheelBehavior && options.wheelBehavior !== "none") {
      activeWheelHandler = function (e) {
        if (options.wheelBehavior === "stop") {
          scrollBlock.off(wheelEvents, activeWheelHandler);
          scrollBlock.stop();
        } else if (options.wheelBehavior === "ignore") {
          e.preventDefault();
        }
      };
      activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler);
    }

    // start scrolling animation
    scrollBlock.stop().animate(
      {
        scrollLeft: offset.left,
        scrollTop: offset.top,
      },
      options.duration,
      function () {
        if (activeWheelHandler) {
          scrollBlock.off(wheelEvents, activeWheelHandler);
        }
        if ($.isFunction(callback)) {
          callback();
        }
      }
    );
  }

  // smooth scroll contstructor
  function SmoothScroll(options) {
    this.options = $.extend(
      {
        anchorLinks: 'a[href^="#"]', // selector or jQuery object
        container: null, // specify container for scrolling (default - whole page)
        extraOffset: null, // function or fixed number
        activeClasses: null, // null, "link", "parent"
        easing: "swing", // easing of scrolling
        animMode: "duration", // or "speed" mode
        animDuration: 800, // total duration for scroll (any distance)
        animSpeed: 1500, // pixels per second
        anchorActiveClass: "anchor-active",
        sectionActiveClass: "section-active",
        wheelBehavior: "stop", // "stop", "ignore" or "none"
        useNativeAnchorScrolling: false, // do not handle click in devices with native smooth scrolling
      },
      options
    );
    this.init();
  }
  SmoothScroll.prototype = {
    init: function () {
      this.initStructure();
      this.attachEvents();
      this.isInit = true;
    },
    initStructure: function () {
      var self = this;

      this.container = this.options.container
        ? $(this.options.container)
        : $("html,body");
      this.scrollContainer = this.options.container ? this.container : win;
      this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
        return jQuery(self.getAnchorTarget(jQuery(this))).length;
      });
    },
    getId: function (str) {
      try {
        return "#" + str.replace(/^.*?(#|$)/, "");
      } catch (err) {
        return null;
      }
    },
    getAnchorTarget: function (link) {
      // get target block from link href
      var targetId = this.getId($(link).attr("href"));
      return $(targetId.length > 1 ? targetId : "html");
    },
    getTargetOffset: function (block) {
      // get target offset
      var blockOffset = block.offset().top;
      if (this.options.container) {
        blockOffset -=
          this.container.offset().top - this.container.prop("scrollTop");
      }

      // handle extra offset
      if (typeof this.options.extraOffset === "number") {
        blockOffset -= this.options.extraOffset;
      } else if (typeof this.options.extraOffset === "function") {
        blockOffset -= this.options.extraOffset(block);
      }
      return {
        top: blockOffset,
      };
    },
    attachEvents: function () {
      var self = this;

      // handle active classes
      if (this.options.activeClasses && this.anchorLinks.length) {
        // cache structure
        this.anchorData = [];

        for (var i = 0; i < this.anchorLinks.length; i++) {
          var link = jQuery(this.anchorLinks[i]),
            targetBlock = self.getAnchorTarget(link),
            anchorDataItem = null;

          $.each(self.anchorData, function (index, item) {
            if (item.block[0] === targetBlock[0]) {
              anchorDataItem = item;
            }
          });

          if (anchorDataItem) {
            anchorDataItem.link = anchorDataItem.link.add(link);
          } else {
            self.anchorData.push({
              link: link,
              block: targetBlock,
            });
          }
        }

        // add additional event handlers
        this.resizeHandler = function () {
          if (!self.isInit) return;
          self.recalculateOffsets();
        };
        this.scrollHandler = function () {
          self.refreshActiveClass();
        };

        this.recalculateOffsets();
        this.scrollContainer.on("scroll", this.scrollHandler);
        win.on(
          "resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll",
          this.resizeHandler
        );
      }

      // handle click event
      this.clickHandler = function (e) {
        self.onClick(e);
      };
      if (!this.options.useNativeAnchorScrolling) {
        this.anchorLinks.on("click", this.clickHandler);
      }
    },
    recalculateOffsets: function () {
      var self = this;
      $.each(this.anchorData, function (index, data) {
        data.offset = self.getTargetOffset(data.block);
        data.height = data.block.outerHeight();
      });
      this.refreshActiveClass();
    },
    toggleActiveClass: function (anchor, block, state) {
      anchor.toggleClass(this.options.anchorActiveClass, state);
      block.toggleClass(this.options.sectionActiveClass, state);
    },
    refreshActiveClass: function () {
      var self = this,
        foundFlag = false,
        containerHeight = this.container.prop("scrollHeight"),
        viewPortHeight = this.scrollContainer.height(),
        scrollTop = this.options.container
          ? this.container.prop("scrollTop")
          : win.scrollTop();

      // user function instead of default handler
      if (this.options.customScrollHandler) {
        this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
        return;
      }

      // sort anchor data by offsets
      this.anchorData.sort(function (a, b) {
        return a.offset.top - b.offset.top;
      });

      // default active class handler
      $.each(this.anchorData, function (index) {
        var reverseIndex = self.anchorData.length - index - 1,
          data = self.anchorData[reverseIndex],
          anchorElement =
            self.options.activeClasses === "parent"
              ? data.link.parent()
              : data.link;

        if (scrollTop >= containerHeight - viewPortHeight) {
          // handle last section
          if (reverseIndex === self.anchorData.length - 1) {
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        } else {
          // handle other sections
          if (
            !foundFlag &&
            (scrollTop >= data.offset.top - 1 || reverseIndex === 0)
          ) {
            foundFlag = true;
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        }
      });
    },
    calculateScrollDuration: function (offset) {
      var distance;
      if (this.options.animMode === "speed") {
        distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
        return (distance / this.options.animSpeed) * 1000;
      } else {
        return this.options.animDuration;
      }
    },
    onClick: function (e) {
      var targetBlock = this.getAnchorTarget(e.currentTarget),
        targetOffset = this.getTargetOffset(targetBlock);

      e.preventDefault();
      scrollTo(targetOffset, {
        container: this.container,
        wheelBehavior: this.options.wheelBehavior,
        duration: this.calculateScrollDuration(targetOffset),
      });
      this.makeCallback("onBeforeScroll", e.currentTarget);
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === "function") {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function () {
      var self = this;

      this.isInit = false;
      if (this.options.activeClasses) {
        win.off(
          "resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll",
          this.resizeHandler
        );
        this.scrollContainer.off("scroll", this.scrollHandler);
        $.each(this.anchorData, function (index) {
          var reverseIndex = self.anchorData.length - index - 1,
            data = self.anchorData[reverseIndex],
            anchorElement =
              self.options.activeClasses === "parent"
                ? data.link.parent()
                : data.link;

          self.toggleActiveClass(anchorElement, data.block, false);
        });
      }
      this.anchorLinks.off("click", this.clickHandler);
    },
  };

  // public API
  $.extend(SmoothScroll, {
    scrollTo: function (blockOrOffset, durationOrOptions, callback) {
      scrollTo(blockOrOffset, durationOrOptions, callback);
    },
  });

  // export module
  exports.SmoothScroll = SmoothScroll;
})(jQuery, this);

/*
 * jQuery Open/Close plugin
 */
(function ($) {
  function OpenClose(options) {
    this.options = $.extend(
      {
        addClassBeforeAnimation: true,
        hideOnClickOutside: false,
        activeClass: "active",
        opener: ".opener",
        slider: ".slide",
        animSpeed: 400,
        effect: "fade",
        event: "click",
      },
      options
    );
    this.init();
  }
  OpenClose.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.makeCallback("onInit", this);
      }
    },
    findElements: function () {
      this.holder = $(this.options.holder);
      this.opener = this.holder.find(this.options.opener);
      this.slider = this.holder.find(this.options.slider);
    },
    attachEvents: function () {
      // add handler
      var self = this;
      this.eventHandler = function (e) {
        e.preventDefault();
        if (self.slider.hasClass(slideHiddenClass)) {
          self.showSlide();
        } else {
          self.hideSlide();
        }
      };
      self.opener.on(self.options.event, this.eventHandler);

      // hover mode handler
      if (self.options.event === "hover") {
        self.opener.on("mouseenter", function () {
          if (!self.holder.hasClass(self.options.activeClass)) {
            self.showSlide();
          }
        });
        self.holder.on("mouseleave", function () {
          self.hideSlide();
        });
      }

      // outside click handler
      self.outsideClickHandler = function (e) {
        if (self.options.hideOnClickOutside) {
          var target = $(e.target);
          if (!target.is(self.holder) && !target.closest(self.holder).length) {
            self.hideSlide();
          }
        }
      };

      // set initial styles
      if (this.holder.hasClass(this.options.activeClass)) {
        $(document).on("click touchstart", self.outsideClickHandler);
      } else {
        this.slider.addClass(slideHiddenClass);
      }
    },
    showSlide: function () {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.addClass(self.options.activeClass);
      }
      self.slider.removeClass(slideHiddenClass);
      $(document).on("click touchstart", self.outsideClickHandler);

      self.makeCallback("animStart", true);
      toggleEffects[self.options.effect].show({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.addClass(self.options.activeClass);
          }
          self.makeCallback("animEnd", true);
        },
      });
    },
    hideSlide: function () {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.removeClass(self.options.activeClass);
      }
      $(document).off("click touchstart", self.outsideClickHandler);

      self.makeCallback("animStart", false);
      toggleEffects[self.options.effect].hide({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.removeClass(self.options.activeClass);
          }
          self.slider.addClass(slideHiddenClass);
          self.makeCallback("animEnd", false);
        },
      });
    },
    destroy: function () {
      this.slider.removeClass(slideHiddenClass).css({
        display: "",
      });
      this.opener.off(this.options.event, this.eventHandler);
      this.holder.removeClass(this.options.activeClass).removeData("OpenClose");
      $(document).off("click touchstart", this.outsideClickHandler);
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === "function") {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
  };

  // add stylesheet for slide on DOMReady
  var slideHiddenClass = "js-slide-hidden";
  (function () {
    var tabStyleSheet = $('<style type="text/css">')[0];
    var tabStyleRule = "." + slideHiddenClass;
    tabStyleRule +=
      "{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}";
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
    }
    $("head").append(tabStyleSheet);
  })();

  // animation effects
  var toggleEffects = {
    slide: {
      show: function (o) {
        o.box.stop(true).hide().slideDown(o.speed, o.complete);
      },
      hide: function (o) {
        o.box.stop(true).slideUp(o.speed, o.complete);
      },
    },
    fade: {
      show: function (o) {
        o.box.stop(true).hide().fadeIn(o.speed, o.complete);
      },
      hide: function (o) {
        o.box.stop(true).fadeOut(o.speed, o.complete);
      },
    },
    none: {
      show: function (o) {
        o.box.hide().show(0, o.complete);
      },
      hide: function (o) {
        o.box.hide(0, o.complete);
      },
    },
  };

  // jQuery plugin interface
  $.fn.openClose = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    return this.each(function () {
      var $holder = jQuery(this);
      var instance = $holder.data("OpenClose");

      if (typeof opt === "object" || typeof opt === "undefined") {
        $holder.data(
          "OpenClose",
          new OpenClose(
            $.extend(
              {
                holder: this,
              },
              opt
            )
          )
        );
      } else if (typeof method === "string" && instance) {
        if (typeof instance[method] === "function") {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
})(jQuery);
